/* Navigation and native Shopify forms; no third-party storefront dependencies. */
(() => {
  if (window.dsStorefrontReady) return;
  window.dsStorefrontReady = true;
  const openers = new WeakMap();
  const syncScrollLock = () => document.documentElement.classList.toggle('ds-dialog-open', !!document.querySelector('dialog.ds-dialog[open]'));
  const close = dialog => {
    if (!dialog || !dialog.open) return;
    dialog.close();
  };
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-ds-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.dsOpen);
      if (!dialog || typeof dialog.showModal !== 'function') return;
      document.querySelectorAll('dialog.ds-dialog[open]').forEach(close);
      openers.set(dialog, opener);
      dialog.showModal();
      opener.setAttribute('aria-expanded', 'true');
      syncScrollLock();
      const input = dialog.querySelector('input[type="search"]');
      if (input) input.focus();
      return;
    }
    const closer = event.target.closest('[data-ds-close]');
    if (closer) close(closer.closest('dialog'));
    if (event.target.matches('dialog.ds-dialog')) close(event.target);
  });
  document.addEventListener('close', event => {
    if (!event.target.matches('dialog.ds-dialog')) return;
    const opener = openers.get(event.target);
    if (opener) {
      opener.setAttribute('aria-expanded', 'false');
      if (opener.isConnected) opener.focus();
    }
    syncScrollLock();
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.ds-nav-details[open]').forEach(details => { details.open = false; });
  });
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('dialog.ds-dialog[open]').forEach(close);
    syncScrollLock();
  });
  document.addEventListener('shopify:block:select', event => {
    const details = event.target.querySelector('.ds-nav-details');
    if (details) details.open = true;
  });
  document.addEventListener('shopify:cart:lines-update', event => {
    if (!event.promise) return;
    Promise.resolve(event.promise).then(data => {
      const count = data?.cart?.totalQuantity ?? data?.cart?.item_count ?? data?.detail?.itemCount;
      if (count === undefined) return;
      document.querySelectorAll('[data-ds-cart-count]').forEach(badge => { badge.textContent = count; badge.hidden = count === 0; });
    }).catch(() => {});
  });
  class DsHeader extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.querySelectorAll('.ds-nav-details').forEach(details => {
        details.addEventListener('pointerenter', () => {
          if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
          this.querySelectorAll('.ds-nav-details[open]').forEach(other => { if (other !== details) other.open = false; });
          if (!details.open) details.dataset.dsHoverOpen = 'true';
          details.open = true;
        }, options);
        details.addEventListener('pointerleave', () => {
          if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
            delete details.dataset.dsHoverOpen;
            details.open = false;
          }
        }, options);
        details.querySelector('summary')?.addEventListener('click', event => {
          if (details.dataset.dsHoverOpen === 'true') {
            event.preventDefault();
            delete details.dataset.dsHoverOpen;
            details.open = true;
          }
        }, options);
        details.addEventListener('toggle', () => {
          if (!details.open) { delete details.dataset.dsHoverOpen; return; }
          this.querySelectorAll('.ds-nav-details[open]').forEach(other => { if (other !== details) other.open = false; });
        }, options);
      });
    }
    disconnectedCallback() { this.controller?.abort(); }
  }
  if (!customElements.get('ds-header')) customElements.define('ds-header', DsHeader);
})();
